import React from 'react';
import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import { Box } from '../../base/Box/Box';
import { Type } from '../../base/Type/Type';
import Link from '../../base/Link/Link';

const description = `
At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis.
`;

const getTargetImage = ({ logo }: Props) =>
  getImage(logo?.images?.slice(-1)[0]);

const buildSectorString = ({ sectors }: Props) => sectors[0];

type Props = {
  name: string;
  description: string;
  sectors: string[];
  link: string;
  logo: any;
};

export const PortfolioCard = (props: Props) => {
  const targetImage = getTargetImage(props);

  return (
    <Box
      as="div"
      className="flex flex-col items-center justify-center rounded-md border-ffBlack max-w-[270px] max-h-[484px]"
    >
      <Box
        as="div"
        className="w-full flex border-x border-t border-ffBlack rounded-t-md"
        style={{ height: '152px' }}
      >
        <Box as="div" className="w-full p-4 flex items-center justify-center">
          <GatsbyImage image={targetImage} objectFit="fill" alt={props.name} />
        </Box>
      </Box>
      <Box
        as="div"
        className="bg-ffLightGrey w-full p-6 flex flex-col border border-ffBlack rounded-b-md"
      >
        <Box as="div" className="flex mt-1 space-x-3 items-center mb-3">
          <div className="h-4 w-4 flex-shrink-0 rounded-full bg-ffBlack content-['']" />
          <Type as="p" className="font-foundersGrotesk text-p1">
            {buildSectorString(props)}
          </Type>
        </Box>
        <Type as="h3" className="font-foundersGrotesk text-[24px] mt-6">
          {props.name}
        </Type>
        <Box as="div" className="h-[116px]">
          <Type
            as="p"
            className="mt-1 text-p1 text-base"
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 5,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {props.description || description}
          </Type>
        </Box>
        <Box as="div" className="flex flex-col justify-end mt-7">
          <Link href={props.link} title={props.name}>
            <Type
              as="p"
              className="underline font-foundersGrotesk text-p1 hover:opacity-80"
            >
              Visit site
            </Type>
          </Link>
        </Box>
      </Box>
    </Box>
  );
};
